import axios from 'axios';

const superAdminApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
});

superAdminApiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('superAdminToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

superAdminApiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // 401/403 handling is now managed globally in axiosGlobalConfig.js
        return Promise.reject(error);
    }
);

export default superAdminApiClient;
